{
  "addButtonLabel": "Tāpiri rongoā",
  "dose": "Inenga",
  "dosePlaceholder": "e.g. 500mg or 1 tablet",
  "dropHere": "Tukua ki konei",
  "dropText": "<p>{{fileExtensions}}, {{fileExtension}}, tae atu ki te {{mb}}MB</p>",
  "dropTitle": "<p><strong>Tukuatu he kōnae</strong> rānei tōia, tukuna iho</p>",
  "frequency": "Auautanga",
  "manuallyText": "<strong>Taapirihia ngā rongoā ā-ringa</strong><p>Tāpirihia tētahi rongoā kotahi i ia wā. Whakaurua te ingoa, te horopeta me te auautanga o te tango.</p>",
  "medicationName": "Ingoa rongoā",
  "medicationPlaceholder": "<p><strong>Tāuruhia mā te reo Pākehā.</strong><br/>Hei tauira: Metformin – 500mg morning and night</p>",
  "nextLabel": "$t(common:next): <b>Hītori</b>",
  "saveButton": "Tiaki rongoā",
  "select": {
    "as-needed": "Ina hiahiatia",
    "once-daily": "Kotahi i te rā",
    "three-time-daily": "E toru i te rā",
    "twice-daily": "E rua i te rā"
  },
  "text": "<p>Tēnā whakamōhiotia mai ngā rongoā, ngā inhaler, ngā werohanga, me ngā kiritaki tāpiri kei te whakamahia e koe ināianei.</p>\n<p>Ka taea e koe te tukuake rārangi, ā, tāpirihia ā-ringa hoki.</p>",
  "title": "Ngā rongoā",
  "uploadText": "<strong>Tukua ake he rongoā rānei he rārangi</strong>\n<p>Mēnā he rārangi ā tō rata, ā tō whare rongoā rānei, tukuna ake he whakaahua, he PDF rānei.</p>"
}
